import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils";

interface TransferAmountTextProps {
  /** ยอดที่ต้องโอน — always shown, even with no submission. */
  required: number | null | undefined;
  /** ยอดโอนจริง — null/undefined = ยังไม่มีการส่งยอด. */
  transfer: number | null | undefined;
}

/**
 * Shared "ที่ต้องโอน/ยอดโอน" cell content, reused by the HO Sale Deposit Report
 * and the BO Sale Daily Report so the compare rule lives in one place:
 *  - no submission (transfer null) → `{required}/ยังไม่มียอด`, muted
 *  - equal (numeric)              → `{required}/{transfer}`, normal
 *  - different (numeric)          → `{required}/{transfer}`, red (error.main)
 */
export default function TransferAmountText({
  required,
  transfer,
}: TransferAmountTextProps) {
  const requiredText = formatNumber(required);

  if (transfer == null) {
    return (
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        component="span"
      >
        <Typography component="span" variant="body2">
          {requiredText}/
        </Typography>
        <Typography component="span" variant="body2" color="text.secondary">
          ยังไม่มียอด
        </Typography>
      </Box>
    );
  }

  const isMatch = Number(required) === Number(transfer);

  return (
    <Typography
      variant="body2"
      sx={{ color: isMatch ? "inherit" : "error.main", whiteSpace: "nowrap" }}
    >
      {requiredText}/{formatNumber(transfer)}
    </Typography>
  );
}
